/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import {
  fetchProductTraceByInternalOrderId,
  fetchTraceGraphByInternalOrderId,
} from '@/api/orders';
import { OrderProductTracingTab } from '@/app/(client)/orders/-components/OrderProductTracingTab';
import {
  productTraceKeys,
  useProductTraceByInternalOrderId,
} from '@/app/(client)/orders/-hooks/useProductTrace';
import {
  internalOrderTraceGraphKeys,
  useTraceGraphByInternalOrderId,
} from '@/app/(client)/orders/-hooks/useTraceGraphByInternalOrderId';
import { Skeleton } from '@/components/ui/skeleton';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/products',
)({
  loader: ({ params }) =>
    Promise.all([
      queryClient.ensureQueryData({
        queryKey: productTraceKeys.internalDetail(params.ioId),
        queryFn: () => fetchProductTraceByInternalOrderId(params.ioId),
      }),
      queryClient.ensureQueryData({
        queryKey: internalOrderTraceGraphKeys.detail(params.ioId),
        queryFn: () =>
          fetchTraceGraphByInternalOrderId(params.ioId).then(r => r.data),
      }),
    ]),
  component: InternalOrderProductsRoute,
});

function InternalOrderProductsRoute() {
  const { ioId } = Route.useParams();
  const { data: productTrace, isLoading } =
    useProductTraceByInternalOrderId(ioId);
  const { data: traceGraph } = useTraceGraphByInternalOrderId(ioId);

  const tracingMeta = traceGraph?.meta
    ? { type: traceGraph.meta.type, orderId: traceGraph.meta.orderId }
    : undefined;

  if (isLoading) {
    return (
      <div className='flex flex-col gap-4'>
        <Skeleton className='h-8 w-40' />
        <Skeleton className='w-full rounded-xl h-96' />
      </div>
    );
  }

  return (
    <OrderProductTracingTab
      data={productTrace ?? { layers: [], links: [] }}
      orderId={ioId}
      {...(tracingMeta ? { tracingMeta } : {})}
    />
  );
}
